import React, { useEffect } from 'react';
import '../styles/BuyScripts.css';
import '../styles/Mobile.css';

const Mobile = () => {
  useEffect(() => {
    document.body.classList.add('mobile-page-active');

    return () => {
      document.body.classList.remove('mobile-page-active');
    };
  }, []);

  return (
    <div className="mobile-page">
      <section className="mobile-hero-image">
        <img src={`${process.env.PUBLIC_URL}/images/mobile/mobile-hero.jpg`} alt="Fiktion mobile hero" />
      </section>

      <div className="book-title pt-0 title-overlay">
        <h1>Take your scripts anywhere</h1>
        <p>Screenwriting in it’s most compact form, right in your pocket.</p>
      </div>

      <section className="mobile-two-column section-marg">
        <article className="mobile-column">
          <div className="mobile-graphic-square">
            <div className="mobile-fake-phone-wrapper">
              <div className="mobile-fake-phone">
                <div className="mobile-fake-phone-inner mobile-writing-ui">
                  <div className="writing-popout-wrapper">
                    <div className="mobile-writing-pill">
                      <span>Action</span>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 3.61763L7.31376 3.61763C7.95308 3.61763 8.28288 4.38183 7.84431 4.847L5.53055 7.30111C5.24272 7.6064 4.75728 7.6064 4.46945 7.30111L2.15569 4.847C1.71712 4.38183 2.04692 3.61763 2.68624 3.61763L5 3.61763Z" fill="white" />
                      </svg>
                    </div>
                    <div className="mobile-writing-menu">
                      <div className="mobile-writing-item">Scene Heading</div>
                      <div className="mobile-writing-item mobile-writing-item-active">Action</div>
                      <div className="mobile-writing-item">Character</div>
                      <div className="mobile-writing-item">Parenthetical</div>
                      <div className="mobile-writing-item">Dialogue</div>
                      <div className="mobile-writing-item">Transition</div>
                      <div className="mobile-writing-item">Shot</div>
                    </div>
                  </div>
                  <div className="script-layout">
                    <div data-type="action" className="action">Jack nods and wipes his hands together in excitement. He’s ready to listen.</div>
                    <div data-type="character" className="character">Cara</div>
                    <div data-type="dialogue" className="dialogue">We're talking about dad's will and you’re ordering champagne?</div>
                    <div data-type="character" className="character">Jack</div>
                    <div data-type="dialogue" className="dialogue">Could you just for one second stop acting so god damn perfect all the time? If dad could see us right now, what would he want us to do?</div>
                    <div data-type="action" className="action">Jack points at Michael. Michael hesitates, but Jack insists.</div>
                    <div data-type="character" className="character">MichaEL</div>
                    <div data-type="dialogue" className="dialogue">He would expect us to order something nice in his memory.</div>
                    <div data-type="character" className="character">Jack</div>
                    <div data-type="dialogue" className="dialogue">Bingo. I’m just following orders. What does the will say?</div>
                    <div data-type="action" className="action">Michael reaches into his bag and hands Jack a stack of joined papers. Jack leans forward and skims through it. A few seconds later, he looks up.</div>
                    <div data-type="character" className="character">Jack</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h6 className="mobile-column-header">Write from whereever</h6>
          <p className="mobile-column-paragraph">
            A super simple editing experience on mobile, so you can continue writing wherever you are.
          </p>
        </article>

        <article className="mobile-column">
          <div className="mobile-graphic-square">
            <div className="mobile-fake-phone-wrapper flex-end">
              <div className="mobile-fake-phone">
                <div className="mobile-fake-phone-inner mobile-fake-phone-inner-ui justify-end">
                  <div className="mobile-ui-top-row">
                    <div className="mobile-ui-project-pill">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2244_2745)">
                          <path d="M6.73485 4.28838C3.85972 7.96836 4.28409 10.1342 4.85566 10.7572L7.59076 7.25641C7.78149 7.01228 8.13401 6.969 8.37813 7.15973C8.62226 7.35046 8.66554 7.70298 8.47481 7.94711L1.86212 16.411C1.79913 16.4916 1.88352 16.6036 1.97838 16.5652L3.16954 16.084C3.3323 16.0182 3.47488 15.9108 3.58295 15.7725L5.55062 13.254C5.6606 13.1132 5.83723 13.0438 6.01532 13.0577C7.97247 13.2095 10.0103 12.1554 11.0799 11.4047C11.24 11.2924 11.2 11.0529 11.0157 10.9874L10.4497 10.7863C10.3622 10.7552 10.3606 10.632 10.4473 10.5987L12.335 9.87272C12.4195 9.84019 12.4937 9.78529 12.5495 9.71387L13.242 8.82748C13.3564 8.68103 13.2767 8.46537 13.0946 8.42853L11.9871 8.20452C11.8901 8.1849 11.8775 8.05142 11.969 8.01395L14.5289 6.9664C14.6899 6.90049 14.834 6.79505 14.9308 6.65041C16.285 4.62642 14.4263 2.7194 13.2859 1.99876C12.3002 1.22863 9.60997 0.608387 6.73485 4.28838Z" fill="#fff" />
                        </g>
                      </svg>
                      <span className="mobile-ui-project-text">
                        <span>While we're...</span>
                      </span>
                      <span className="mobile-ui-caret"></span>
                    </div>
                    <div className="flex gap-2">
                      <div className="mobile-ui-circle-btn">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.5885 3.45841C15.3939 2.65295 16.6998 2.65295 17.5053 3.45841L18.5399 4.49304C19.3454 5.2985 19.3454 6.6044 18.5399 7.40986L17.4159 8.5339L13.4644 4.58245L14.5885 3.45841Z" stroke="white" stroke-width="1.5" />
                          <path d="M13.4687 4.58066L17.4185 8.53042L8.78522 17.1637C8.43564 17.5133 7.97212 17.7257 7.47908 17.7622L5.16647 17.9334C4.53761 17.9799 4.0146 17.4562 4.06201 16.8274L4.23608 14.5184C4.27318 14.0264 4.48544 13.564 4.83434 13.2151L13.4687 4.58066Z" stroke="white" stroke-width="1.5" />
                          <path d="M5.49219 12.5555L9.44195 16.5052" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                      <div className="mobile-ui-circle-btn">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 4.14286V17.8571" stroke="white" stroke-width="1.75" stroke-linecap="round" />
                          <path d="M4.14453 11L17.8588 11" stroke="white" stroke-width="1.75" stroke-linecap="round" />
                        </svg>
                      </div>
                      <div className="mobile-ui-circle-btn">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.0004" cy="11" r="4.27778" stroke="white" stroke-width="1.5" />
                          <path d="M11 4.27778V1.83334" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M11 20.1667V17.7222" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M4.27648 11L1.83203 11" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M20.1671 11L17.7227 11" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M6.24411 15.7534L4.51562 17.4819" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M17.4824 4.51825L15.7539 6.24673" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M15.7559 15.7534L17.4844 17.4819" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M4.51761 4.51825L6.24609 6.24673" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="mobile-ui-menu-card">
                    <div className="mobile-ui-menu-item-simple">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.25" y="5.60001" width="7" height="7.7" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="15.75" y="5.60001" width="7" height="5.6" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="5.25" y="16.8" width="7" height="5.6" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="15.75" y="14.7" width="7" height="7.7" rx="1.4" stroke="white" stroke-width="1.75" />
                      </svg>
                      <span>Outline</span>
                    </div>
                    <div className="mobile-ui-menu-item-simple">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10.85C7 9.87423 7 9.38634 7.0807 8.98063C7.41211 7.31453 8.71452 6.01212 10.3806 5.68071C10.7863 5.60001 11.2742 5.60001 12.25 5.60001C13.8763 5.60001 14.6894 5.60001 15.3656 5.73451C18.1425 6.28686 20.3131 8.45754 20.8655 11.2344C21 11.9106 21 12.7237 21 14.35V16.1C21 18.057 21 19.0354 20.6803 19.8073C20.254 20.8364 19.4364 21.654 18.4073 22.0803C17.6354 22.4 16.657 22.4 14.7 22.4H13.762C11.3701 22.4 10.1742 22.4 9.26391 21.9271C8.49681 21.5287 7.87134 20.9032 7.47286 20.1361C7 19.2258 7 18.0299 7 15.638V10.85Z" stroke="white" stroke-width="1.75" />
                        <path d="M14 6.29999C14 7.09618 14 7.77035 14 8.40018C14 10.7198 15.8804 12.6 18.2 12.6H20.3" stroke="white" stroke-width="1.75" stroke-linecap="round" />
                      </svg>
                      <span>Script</span>
                    </div>
                    <div className="mobile-ui-menu-item-simple">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4.89844" y="4.89999" width="18.2" height="18.2" rx="4.2" stroke="white" stroke-width="1.75" />
                        <circle cx="13.9977" cy="11.9" r="3.15" fill="white" />
                        <path d="M9.98822 19.6875H13.9997H18.0113C18.7275 19.6875 19.3081 19.1069 19.3081 18.3907C19.3081 17.8117 18.9242 17.3028 18.3675 17.1438L17.3453 16.8517C15.1587 16.227 12.8408 16.227 10.6542 16.8517L9.63196 17.1438C9.07523 17.3028 8.69141 17.8117 8.69141 18.3907C8.69141 19.1069 9.27201 19.6875 9.98822 19.6875Z" fill="white" />
                      </svg>
                      <span>Characters</span>
                    </div>
                    <div className="mobile-ui-menu-item-simple">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9615 10.08H12.0415C9.6092 10.08 9.10156 10.5876 9.10156 13.02V23.7999H18.9015V13.02C18.9015 10.5876 18.3939 10.08 15.9615 10.08Z" stroke="white" stroke-width="1.75" stroke-linejoin="round" />
                        <path d="M13.0195 14H14.9795M13.0195 16.94H14.9795M13.0195 19.88H14.9795" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M23.1009 23.8V10.262C23.1009 9.05829 23.1009 8.45642 22.8082 7.97276C22.5154 7.48909 21.9883 7.21994 20.934 6.68161L16.3987 4.50907C15.2615 3.9284 14.9805 4.13304 14.9805 5.40416V9.78942" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.89844 23.8V14.98C4.89844 14.1692 5.06765 14 5.87843 14H9.09835" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M24.5 23.8H3.5" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>Locations</span>
                    </div>
                    <div className="mobile-ui-menu-item-simple">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 5.60001V22.4" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.60547 14.007L22.4055 14.007" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M8.07031 19.9445L19.9497 8.0651" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M19.9531 19.9346L8.07373 8.05524" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      <span>Ideas</span>
                    </div>
                  </div>

                  <div className="mobile-ui-bottom-bar-simple">
                    <span className="mobile-ui-bottom-dot">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5.25" y="5.60001" width="7" height="7.7" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="15.75" y="5.60001" width="7" height="5.6" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="5.25" y="16.8" width="7" height="5.6" rx="1.4" stroke="white" stroke-width="1.75" />
                        <rect x="15.75" y="14.7" width="7" height="7.7" rx="1.4" stroke="white" stroke-width="1.75" />
                      </svg>
                    </span>
                    <span className="mobile-ui-bottom-dot">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10.85C7 9.87423 7 9.38634 7.0807 8.98063C7.41211 7.31453 8.71452 6.01212 10.3806 5.68071C10.7863 5.60001 11.2742 5.60001 12.25 5.60001C13.8763 5.60001 14.6894 5.60001 15.3656 5.73451C18.1425 6.28686 20.3131 8.45754 20.8655 11.2344C21 11.9106 21 12.7237 21 14.35V16.1C21 18.057 21 19.0354 20.6803 19.8073C20.254 20.8364 19.4364 21.654 18.4073 22.0803C17.6354 22.4 16.657 22.4 14.7 22.4H13.762C11.3701 22.4 10.1742 22.4 9.26391 21.9271C8.49681 21.5287 7.87134 20.9032 7.47286 20.1361C7 19.2258 7 18.0299 7 15.638V10.85Z" stroke="white" stroke-width="1.75" />
                        <path d="M14 6.29999C14 7.09618 14 7.77035 14 8.40018C14 10.7198 15.8804 12.6 18.2 12.6H20.3" stroke="white" stroke-width="1.75" stroke-linecap="round" />
                      </svg>
                    </span>
                    <span className="mobile-ui-bottom-dot">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4.89844" y="4.89999" width="18.2" height="18.2" rx="4.2" stroke="white" stroke-width="1.75" />
                        <circle cx="13.9977" cy="11.9" r="3.15" fill="white" />
                        <path d="M9.98822 19.6875H13.9997H18.0113C18.7275 19.6875 19.3081 19.1069 19.3081 18.3907C19.3081 17.8117 18.9242 17.3028 18.3675 17.1438L17.3453 16.8517C15.1587 16.227 12.8408 16.227 10.6542 16.8517L9.63196 17.1438C9.07523 17.3028 8.69141 17.8117 8.69141 18.3907C8.69141 19.1069 9.27201 19.6875 9.98822 19.6875Z" fill="white" />
                      </svg>
                    </span>
                    <span className="mobile-ui-bottom-dot">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9615 10.08H12.0415C9.6092 10.08 9.10156 10.5876 9.10156 13.02V23.7999H18.9015V13.02C18.9015 10.5876 18.3939 10.08 15.9615 10.08Z" stroke="white" stroke-width="1.75" stroke-linejoin="round" />
                        <path d="M13.0195 14H14.9795M13.0195 16.94H14.9795M13.0195 19.88H14.9795" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M23.1009 23.8V10.262C23.1009 9.05829 23.1009 8.45642 22.8082 7.97276C22.5154 7.48909 21.9883 7.21994 20.934 6.68161L16.3987 4.50907C15.2615 3.9284 14.9805 4.13304 14.9805 5.40416V9.78942" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4.89844 23.8V14.98C4.89844 14.1692 5.06765 14 5.87843 14H9.09835" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M24.5 23.8H3.5" stroke="white" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <span className="mobile-ui-bottom-active-pill">
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.77734 11.6666L13.9996 5.44443L20.2218 11.6666" stroke="white" stroke-width="1.55556" />
                        <path d="M20.2218 16.3333L13.9996 22.5555L7.77734 16.3333" stroke="white" stroke-width="1.55556" />
                      </svg>

                    </span>
                  </div>

                  <span className="mobile-ui-home-indicator-simple"></span>
                </div>
              </div>
            </div>
          </div>
          <h6 className="mobile-column-header">Simple to navigate</h6>
          <p className="mobile-column-paragraph">
            Designed to be easy to navigate, with all the features you need on the go.
          </p>
        </article>
      </section>

      <section className="mobile-wide-module section-marg">
        <div
          className="mobile-wide-image"
          role="img"
          aria-label="Fiktion app icon preview"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/mobile/app-icon.jpg)` }}
        ></div>
        <h6 className="mobile-column-header">Download</h6>
        <p className="mobile-column-paragraph long-paragraph">
          To download the Fiktion app on your phone from Safari or Chrome, press the "Share" button and select "Add to Home Screen".
        </p>
      </section>

      <section className="mobile-two-column section-marg">
        <article className="mobile-column">
          <div className="mobile-graphic-square">
            <div className="mobile-fake-phone-wrapper">
              <div className="mobile-fake-phone">
                <div className="mobile-fake-phone-inner no-padding">
                  <div class="mobile-character-wrapper">
                    <div class="fake-button-wrapper">
                      <div class="fake-button">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.99994 1.60498C11.9349 1.60511 15.1249 4.79503 15.1249 8.72998C15.1249 11.0409 14.0235 13.0932 12.3183 14.395C12.356 14.2106 12.3738 14.0189 12.3642 13.8218C12.253 12.6667 11.53 11.6606 10.4706 11.187L10.3613 11.1372C8.86195 10.467 7.14804 10.4668 5.64838 11.1362L5.53412 11.187C4.47399 11.6604 3.74916 12.6664 3.6347 13.8218C3.62243 14.0162 3.63723 14.2057 3.67181 14.3882C1.97204 13.086 0.874939 11.0366 0.874939 8.72998C0.874939 4.79495 4.06491 1.60498 7.99994 1.60498ZM8.00482 4.97998C6.76226 4.98007 5.75482 5.98739 5.75482 7.22998C5.75482 8.47257 6.76226 9.47989 8.00482 9.47998C9.24746 9.47998 10.2548 8.47262 10.2548 7.22998C10.2548 5.98734 9.24746 4.97998 8.00482 4.97998Z" fill="#fff"></path>
                        </svg>
                        <p>Lead character</p>
                      </div>
                    </div>
                    <div class="fake-header">
                      <p>Becky Abbott</p>
                    </div>
                    <div class="character-pills">
                      <div class="character-pill">32</div>
                      <div class="character-pill">Female</div>
                      <div class="character-pill">Journalist</div>
                      <div class="character-pill">African-American</div>
                    </div>
                    <div class="fake-character-description">At 32, Becky is already known in newsroom circles for her sharp prose and sharper instincts, a journalist who can find a heartbeat in a headline. She came up in small-town papers, learning to chase stories with more grit than guidance, before landing in a city newsroom that never sleeps.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h6 className="mobile-column-header">Characters and locations</h6>
          <p className="mobile-column-paragraph">
            Make your characters and locations come alive, from traits and details you notice on the go.
          </p>
        </article>

        <article className="mobile-column">
          <div className="mobile-graphic-square">
            <div className="mobile-fake-phone-wrapper flex-start">
              <div className="mobile-fake-phone">
                <div className="mobile-fake-phone-inner">
                  <div className="ideas-tabs">
                    <div className="ideas-tab-large active">
                      <span className="ideas-tab-name">Ideas</span>
                    </div>
                    <div style={{ display: 'inline-block', margin: '0px', padding: '0px', lineHeight: 0 }}>
                      <button className="mobile ideas-tab-add">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7 3V11" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"></path>
                          <path d="M3 7L11 7" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div className="ideas-inner-wrapper">
                    <h6 className="ideas-title">Ideas</h6>
                    <p className="ideas-paragraph">
                      Jot down ideas, chirps of dialogue and sudden sparks of genius.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h6 className="mobile-column-header">Jot down your ideas</h6>
          <p className="mobile-column-paragraph">
            Capture an idea or interesting thought the moment they appear, right where your story happens.
          </p>
        </article>
      </section>
    </div>
  );
};

export default Mobile;
